/**
 * @module custom.icons
 *
 * Custom SVG icons, exported as React components using react-script's loader.
 *
 * @link https://create-react-app.dev/docs/adding-images-fonts-and-files/#adding-svgs
 */
import AboveAvg from '~/assets/images/above_avg.svg?react';
import AllAnonymized from '~/assets/images/all_anonymized.svg?react';
import ArrowRightAlt from '~/assets/images/arrow_right_alt.svg?react';
import Attention from '~/assets/images/attention.svg?react';
import BarTrends from '~/assets/images/bar_trends.svg?react';
import BelowAvg from '~/assets/images/below_avg.svg?react';
import BottomBadge from '~/assets/images/bottom_badge.svg?react';
import Caution from '~/assets/images/warning_amber.svg?react';
import ClipboardCheckmarks from '~/assets/images/clipboard_with_checkmarks.svg?react';
import ContentCopy from '~/assets/images/content_copy.svg?react';
import ContentPasteOutlined from '~/assets/images/content_paste_outlined.svg?react';
import DecreaseBadge from '~/assets/images/decrease_badge.svg?react';
import Factor from '~/assets/images/factor.svg?react';
import IncreaseBadge from '~/assets/images/increase_badge.svg?react';
import Kazoo from '~/assets/images/kazoo.svg?react';
import Logic from '~/assets/images/logic.svg?react';
import Megaphone from '~/assets/images/campaign.svg?react';
import NextArrow from '~/assets/images/next_arrow.svg?react';
import Pencil from '~/assets/images/pencil.svg?react';
import Plus from '~/assets/images/plus.svg?react';
import PPT from '~/assets/images/ppt.svg?react';
import PPTDialog from '~/assets/images/ppt_dialog.svg?react';
import Question from '~/assets/images/question.svg?react';
import Target from '~/assets/images/target.svg?react';
import TopBadge from '~/assets/images/top_badge.svg?react';
import TrashCan from '~/assets/images/trash_can.svg?react';
import TrashCanOutlined from '~/assets/images/trash_can_outlined.svg?react';
import Trend from '~/assets/images/trend.svg?react';
import WorkTangoLogo from '~/assets/images/worktango_logo.svg?react';
import WorkTangoWideWhiteLogo from '~/assets/images/worktango_wide_white_logo.svg?react';
import WorkTangoWordmark from '~/assets/images/worktango_wordmark.svg?react';
import WorkTangoW from '~/assets/images/worktango_w.svg?react';
import XLS from '~/assets/images/xls.svg?react';
import Rule from '~/assets/images/rule.svg?react';
import Slack from '~/assets/images/slack.svg?react';

export const customIcons = {
  AboveAvg,
  AllAnonymized,
  ArrowRightAlt,
  Attention,
  BarTrends,
  BelowAvg,
  BottomBadge,
  Caution,
  ClipboardCheckmarks,
  ContentCopy,
  ContentPasteOutlined,
  DecreaseBadge,
  Factor,
  IncreaseBadge,
  Kazoo,
  Logic,
  Megaphone,
  NextArrow,
  Pencil,
  Plus,
  PPT,
  PPTDialog,
  Question,
  Target,
  TopBadge,
  TrashCan,
  TrashCanOutlined,
  Trend,
  WorkTangoLogo,
  WorkTangoWideWhiteLogo,
  WorkTangoWordmark,
  WorkTangoW,
  XLS,
  Rule,
  Slack,
};
